export interface GeneralResponse<T> {
  status: string;
  message: string;
  body: T;
  success: boolean;
  code?: any;
}

export class CGeneralResponse<T> implements GeneralResponse<T> {
  static generalResponseDesdeObj<T>(obj: object, body: T): CGeneralResponse<T> {
    return new CGeneralResponse<T>(
      obj["status"],
      obj["message"],
      body,
      obj["success"],
      obj["code"]
    );
  }

  constructor(
    public status: string,
    public message: string,
    public body: T,
    public success: boolean,
    public code?: any
  ) { }
}

export interface PageResponse<T> {
  content: T[];
  totalPages: number;
  totalElements: number;
  number: number;
  size: number;
  first: boolean;
  last: boolean;
}

export interface MasApiResponse<T> {
  code: string;
  body: {
    items: T[];
    nextPartitionKey?: string | null;
    nextRowKey?: string | null;
    hasMore: boolean;
  };
  success: boolean;
  message: string | null;
}
